import React from 'react'
import Link from 'gatsby-link'
import Resume from '../components/Resume'

const ResumePage = () => <Resume />

export default ResumePage



// WEBPACK FOOTER //
// ./src/pages/resume.js